import 'babel-polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Router, Route, Switch } from 'react-router';
import { Provider } from 'mobx-react';

import { App } from './_app/app';
import { AppStore } from './_app/app.store';
import { RouterStore } from './router.store';
import { HomeComponent } from './_home/home.component';
import { ContentComponent } from './_content/content.component';
import { CollectionProvider } from './_collection/collection.provider';
import ReactGA from 'react-ga';

import register from './registerServiceWorker';

import Modernizr from 'modernizr';

console.log(Modernizr);

require('viewport-units-buggyfill').init();

register();

const appStore = AppStore.getInstance(),
    routerStore = RouterStore.getInstance(),
    rootStores = {
        appStore,
        routerStore
    };
ReactDOM.render(
    <Provider {...rootStores}>
        <Router history={routerStore.history}>
            <App className='app'>
                <Switch>
                    <Route path='/404' component={ContentComponent} />
                    <Route path='/500' component={ContentComponent} />
                    <Route exact path='/' component={HomeComponent} />
                    {/* <Route exact path='/:collection/about' component={CollectionProvider} about /> */}
                    <Route exact path='/:collection/:artwork?' component={CollectionProvider} />
                </Switch>
            </App>
        </Router>
    </Provider>,
    document.getElementById('root')
);

routerStore.history.listen(location => {
    // Fire event tracking to GTM\
    let url = window.location.pathname + window.location.search + window.location.hash;
    ReactGA.pageview(url);
});



// WEBPACK FOOTER //
// ./src/index.js